import { ContractType } from "@/lib/api/otc";
import { OrderType } from "@/lib/tt/orderType";

export type { OrderType };

export type OtcMode = "hedgeable" | "reown";

export interface CustomerSplitEntry {
  /** Unique key for stable React rendering across reorders/removals. */
  key: string;
  customer_id: string;
  /** Quantity as a string (user-facing). Stored as percentage internally on submit. */
  quantity: string;
}

export interface AttachFormValues {
  customerSplits: CustomerSplitEntry[];
  cropYear: string;
  orderType: OrderType;
  otcMode: OtcMode | null;
  otcContractType: string;
  shouldIgnore: boolean;
  isNonClient: boolean;
}

export const REOWN_CONTRACT_TYPES = new Set<string>([
  ContractType.BasePriceReown,
  ContractType.RangePriceReown,
  ContractType.ReOwnWDU,
]);
